import * as React from "react";
import { useMemo } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { ActiveTradingViewComposeChecklist } from "../../utils/activeTradingViewComposeChecklist";
import {
  activeTradingViewComposeRemainingTone,
  getActiveTradingViewComposeRemainingSteps,
} from "../../utils/activeTradingViewComposeChecklist";
import { STRATEGY_PINE_SECTION_DESC_CLASS, STRATEGY_PINE_SECTION_LABEL_CLASS } from "./StrategyPineSectionCard";
import {
  STRATEGY_PINE_ALERT_CLASS,
  StrategyPineAlertIcon,
  strategyPineAlertVariant,
} from "./strategyPineAlertUi";

export type ActiveTradingViewPineComposeRemainingAlertProps = {
  checklist: ActiveTradingViewComposeChecklist;
};

export function ActiveTradingViewPineComposeRemainingAlert({
  checklist,
}: ActiveTradingViewPineComposeRemainingAlertProps): React.ReactElement | null {
  const remaining = useMemo(
    () => getActiveTradingViewComposeRemainingSteps(checklist),
    [checklist]
  );

  if (remaining.length === 0) return null;

  const tone = activeTradingViewComposeRemainingTone(remaining);

  return (
    <Alert
      variant={strategyPineAlertVariant(tone)}
      className={STRATEGY_PINE_ALERT_CLASS}
      data-strategy-compose-remaining-alert=""
    >
      <StrategyPineAlertIcon tone={tone} />
      <AlertTitle className={STRATEGY_PINE_SECTION_LABEL_CLASS}>
        Complete these steps before you can compose
      </AlertTitle>
      <AlertDescription className={STRATEGY_PINE_SECTION_DESC_CLASS}>
        <ul className="list-disc space-y-1.5 pl-4">
          {remaining.map((item) => (
            <li key={item.id}>
              <span className="font-medium text-[color:var(--brand-tropical-surf)]">{item.title}</span>
              <span> — {item.description}</span>
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
